
// SYNC TO SERVER RESPONSE!
export interface RawLoginResult
{
    Authorized: boolean,
    Message?: string,
    DeviceId?: string
}


export class LoginResult
{
    constructor(
        public IsAuthorized: boolean,
        public IsNetworkError: boolean,
        public Message: string,
        public DeviceId?: string) // TODO: device id comes also with device:connected event, might be removed from here?
    { }

    public static Success(deviceId: string): LoginResult
    {
        return new LoginResult(true, false, "Authorized", deviceId);
    }

    public static Unauthorized(message: string): LoginResult
    {
        return new LoginResult(false, false, message);
    }

    public static NetworkError(message: string): LoginResult
    {
        return new LoginResult(false, true, message);
    }

    public get IsUnauthorized(): boolean
    {
        return this.IsAuthorized == false;
    }
}
